module.exports = __webpack_public_path__ + "neurohub.2b03e021.png";